module.exports = __webpack_public_path__ + "img/logo.282ce8b2.png";